import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { toast } from '@/lib/v2/components';
import { ModalSingleInput } from '@/lib/v2/organisms';

import { AUTOMATION_PATHS } from '@/src/modules/AutomationModuleNew/constants';
import { useCreateJourney } from '@/src/modules/AutomationModuleNew/hooks/Flows';
import { useRulesValidations } from '@/src/modules/AutomationModuleNew/hooks/useRulesValidations';

const JourneyCreateScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { createJourney, isLoading } = useCreateJourney();
  const { VALIDATION_RULES } = useRulesValidations();

  const handleSubmit = useCallback(
    async (name: string) => {
      const response = await createJourney(name);
      if (response?.success) {
        toast({
          id: 'journeyCreated',
          title: t('JourneyCreateScreen.journeyCreated'),
          body: t('JourneyCreateScreen.journeyCreatedBody'),
          variant: 'success',
        });
        const { journeyId } = response.data;
        navigate(
          `/v2/${AUTOMATION_PATHS.MODULE_PATH}/${AUTOMATION_PATHS.JOURNEYS_PATH}/${journeyId}/edit`
        );
      }

      return {
        isValidInput: false,
        message: t('JourneyCreateScreen.duplicateName'),
      };
    },
    [createJourney, navigate, t]
  );

  return (
    <ModalSingleInput
      isOpen
      disabled={isLoading}
      isLoading={isLoading}
      rules={VALIDATION_RULES}
      title="Create new journey"
      onSubmit={handleSubmit}
    />
  );
};

export default JourneyCreateScreen;
